import { createDecorator } from 'vue-class-component';
import { eventCode } from '@/constants/trace-constant';
import { VueDecorator } from 'vue-class-component/lib/util';
import { TraceApiService } from '@/services/api/trace-api-service';

/**
 * Décorateur permettant de log des informations sur l'API
 * @param code code d'événement
 */
export function ApiLog(code: eventCode): VueDecorator {
	return createDecorator((options, key) => {
		if (options.methods) {
			const originalMethod = options.methods[key];

			// Surcharge de la méthode de base
			options.methods[key] = function wrapperMethod(...args) {
				TraceApiService.trace(code);

				originalMethod.apply(this, args);
			};
		}

	});
}
